(function () {
  'use strict';
  function boot(root) {
    if (!root || root.dataset.originalsEngagementMounted === 'true') return;
    root.dataset.originalsEngagementMounted = 'true';
    var configNode = root.querySelector('[data-originals-config]');
    var config = JSON.parse(configNode && configNode.textContent || '{}');
    var audio = root.dsdOriginalsSharedAudio || root.querySelector('[data-originals-audio]');
    var status = root.querySelector('[data-originals-engagement-status]');
    var chapterStatus = root.querySelector('[data-originals-chapter-engagement-status]');
    var passageBookmarksPanel = root.querySelector('[data-originals-passage-bookmarks]');
    var passageBookmarksList = root.querySelector('[data-originals-passage-bookmark-list]');
    var audioBookmarksPanel = root.querySelector('[data-originals-audio-bookmarks]');
    var audioBookmarksList = root.querySelector('[data-originals-audio-bookmark-list]');
    var saveRetryButtons = root.querySelectorAll('[data-originals-save-retry]');
    var sleepStatus = root.querySelector('[data-originals-sleep-status]');
    var sleepSelect = root.querySelector('[data-originals-sleep]');
    var ratingForm = root.querySelector('[data-originals-rating-form]');
    var ratingStatus = root.querySelector('[data-originals-rating-status]');
    var discussionForm = root.querySelector('[data-originals-discussion-form]');
    var discussionStatus = root.querySelector('[data-originals-discussion-status]');
    var discussionList = root.querySelector('[data-originals-discussion-list]');
    var sleepTimer = null;
    var sleepDeadline = null;
    var endSuppressesAutoNext = false;
    var Core = window.DSDOriginalsPolishCore;
    var localScope = Core && Core.localStorageScope(config);
    var prefix = 'dsd-originals-polish-v1:' + (localScope || 'unavailable') + ':';
    var apiBase = '/apps/dsd-firebase-custom-token/originals-polish';
    var accountSync = config.signedIn === true && !!localScope && /^[a-f0-9]{64}$/.test(String(config.requestScope || ''));
    var savedItems = [];
    var savedReady = false;
    var accountChanged = false;
    var passageSavePending = false;
    var passageRemovalPending = new Set();
    var discussionRequest = 0;
    var discussionItems = [];
    var discussionNextPage = null;
    var discussionLoading = false;
    var discussionMore = discussionList ? document.createElement('button') : null;
    if (discussionMore) {
      discussionMore.type = 'button';
      discussionMore.className = 'dsd-originals-polish__comment-more';
      discussionMore.textContent = 'Load more comments';
      discussionMore.setAttribute('aria-label', 'Load more chapter comments');
      discussionMore.addEventListener('click', function () { if (!discussionLoading && discussionNextPage !== null) loadDiscussion(discussionNextPage); });
    }

    function api(path, method, payload) {
      return fetch(apiBase + path, { method: method, credentials: 'same-origin', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: payload ? JSON.stringify(payload) : undefined }).then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (value) { if (!response.ok) { var error = new Error(value.error || 'request_failed'); error.status = response.status; error.code = value.error; throw error; } return value; });
      });
    }

    function read(key, fallback) {
      if (!localScope) return fallback;
      try { return JSON.parse(localStorage.getItem(prefix + key) || 'null') || fallback; } catch (error) { return fallback; }
    }
    function write(key, value) {
      if (!localScope) return false;
      try { localStorage.setItem(prefix + key, JSON.stringify(value)); return true; } catch (error) { return false; }
    }
    function announce(message) { if (status) status.textContent = message; if (chapterStatus) chapterStatus.textContent = message; }
    function showSaveRetry(show) { saveRetryButtons.forEach(function (button) { button.hidden = !show; }); }
    function savedApi(method, payload) { return api('/saved', method, Object.assign({}, payload || {}, { readerScope: config.requestScope })); }
    function hasAccountSave(type, chapterId) {
      return savedItems.some(function (item) { return item.type === type && item.seriesId === 'just-the-homie' && (type === 'favorite_series' || item.chapterId === chapterId); });
    }
    function renderAccountSaves() {
      var favorite = root.querySelector('[data-originals-engagement="favorite"]');
      var chapter = root.querySelector('[data-originals-engagement="save-chapter"]');
      if (favorite) {
        var on = hasAccountSave('favorite_series');
        favorite.setAttribute('aria-pressed', String(on)); favorite.textContent = on ? 'Favorited' : 'Favorite series';
      }
      if (chapter) {
        var saved = hasAccountSave('saved_chapter', activeChapterId());
        chapter.setAttribute('aria-pressed', String(saved)); chapter.textContent = saved ? 'Saved' : 'Save chapter';
      }
      syncSavedCatalog();
      renderPassageBookmarks();
      renderAudioBookmarks();
    }
    function audioBookmarks() {
      var revision = activeAudioRevision();
      var list = config.signedIn ? savedItems : read('bookmarks', []);
      return (Array.isArray(list) ? list : []).filter(function (item) {
        return item && (item.type === 'audio_bookmark' || !config.signedIn) &&
          item.seriesId === 'just-the-homie' && item.chapterId === activeChapterId() &&
          (item.contentRevision || item.audioRevision) === revision &&
          typeof item.positionSeconds === 'number' && Number.isFinite(item.positionSeconds) && item.positionSeconds >= 0;
      });
    }
    function bookmarkTime(position) {
      var seconds = Math.floor(position);
      return Math.floor(seconds / 60) + ':' + String(seconds % 60).padStart(2, '0');
    }
    function removeAudioBookmark(item) {
      if (config.signedIn) {
        if (!accountSync || !savedReady || accountChanged) return void announce('Reload account saves before removing a bookmark.');
        savedApi('DELETE', { type: 'audio_bookmark', seriesId: item.seriesId, chapterId: item.chapterId,
          audioRevision: item.contentRevision || item.audioRevision, positionSeconds: item.positionSeconds,
          anchor: item.anchor || '' }).then(function () {
          if (accountChanged) return;
          savedItems = savedItems.filter(function (saved) {
            return !(saved.type === 'audio_bookmark' && saved.seriesId === item.seriesId &&
              saved.chapterId === item.chapterId && (saved.contentRevision || saved.audioRevision) === (item.contentRevision || item.audioRevision) &&
              (saved.anchor || '') === (item.anchor || ''));
          });
          renderAudioBookmarks(); announce('Timestamp bookmark removed from your DSD account.');
        }).catch(function (error) { if (!accountChanged) bookmarkFailure(error, 'Timestamp bookmark removal'); });
        return;
      }
      var list = read('bookmarks', []);
      if (!Array.isArray(list)) return;
      var remaining = list.filter(function (saved) {
        return !(saved.chapterId === item.chapterId && saved.audioRevision === item.audioRevision && saved.positionSeconds === item.positionSeconds);
      });
      if (!write('bookmarks', remaining)) return void announce('Local bookmark could not be removed.');
      renderAudioBookmarks(); announce('Timestamp bookmark removed from this device.');
    }
    function renderAudioBookmarks() {
      if (!audioBookmarksPanel || !audioBookmarksList) return;
      audioBookmarksList.replaceChildren();
      var list = audioBookmarks();
      audioBookmarksPanel.hidden = list.length === 0;
      list.forEach(function (item) {
        var time = bookmarkTime(item.positionSeconds);
        var pair = document.createElement('span');
        var jump = document.createElement('button'); jump.type = 'button';
        jump.textContent = 'Go to ' + time; jump.setAttribute('aria-label', 'Go to bookmarked time ' + time);
        jump.addEventListener('click', function () {
          var seek = root.querySelector('[data-originals-seek]');
          if (!seek) return void announce('Player seek is unavailable.');
          seek.value = String(item.positionSeconds);
          seek.dispatchEvent(new Event('change', { bubbles: true }));
        });
        var remove = document.createElement('button'); remove.type = 'button';
        remove.textContent = 'Remove'; remove.setAttribute('aria-label', 'Remove bookmark at ' + time);
        remove.addEventListener('click', function () { removeAudioBookmark(item); });
        pair.append(jump, remove); audioBookmarksList.appendChild(pair);
      });
    }
    function passageBookmarks() {
      var version = root.dataset.originalsProseRevision;
      if (!version) return [];
      var list = config.signedIn ? savedItems : read('text-bookmarks', []);
      var anchors = new Set(Array.from(root.querySelectorAll('[data-originals-read] [data-originals-prose-anchor]')).map(function (node) { return node.dataset.originalsProseAnchor; }));
      return (Array.isArray(list) ? list : []).filter(function (item) {
        return item && item.type === 'text_bookmark' && item.seriesId === 'just-the-homie' && item.chapterId === activeChapterId() && (item.contentRevision || item.textVersion) === version && anchors.has(item.anchor);
      });
    }
    function passageKey(item) {
      return [item.seriesId, item.chapterId, item.contentRevision || item.textVersion, item.anchor].join(':');
    }
    function removePassageBookmark(item) {
      var key = passageKey(item);
      if (passageRemovalPending.has(key)) return;
      function keep(saved) { return saved.type !== 'text_bookmark' || passageKey(saved) !== key; }
      if (config.signedIn) {
        if (!accountSync || !savedReady || accountChanged) return void announce('Reload account saves before removing a bookmark.');
        passageRemovalPending.add(key); renderPassageBookmarks();
        savedApi('DELETE', { type: 'text_bookmark', seriesId: item.seriesId, chapterId: item.chapterId,
          textVersion: item.contentRevision || item.textVersion, anchor: item.anchor }).then(function (data) {
          if (accountChanged) return;
          if (!data.item || data.item.deleted !== true) throw new Error('saved_response_invalid');
          savedItems = savedItems.filter(keep);
          announce('Passage bookmark removed from your DSD account.');
        }).catch(function (error) {
          if (!accountChanged) bookmarkFailure(error, 'Passage bookmark removal');
        }).finally(function () {
          passageRemovalPending.delete(key);
          if (!accountChanged) renderPassageBookmarks();
        });
        return;
      }
      if (accountChanged) return;
      var list = read('text-bookmarks', []);
      if (!Array.isArray(list) || !write('text-bookmarks', list.filter(keep))) return void announce('Local bookmark could not be removed.');
      renderPassageBookmarks(); announce('Passage bookmark removed from this device.');
    }
    function renderPassageBookmarks() {
      if (!passageBookmarksPanel || !passageBookmarksList) return;
      passageBookmarksList.replaceChildren();
      var list = passageBookmarks();
      passageBookmarksPanel.hidden = list.length === 0;
      list.forEach(function (item) {
        var button = document.createElement('button');
        button.type = 'button';
        button.dataset.originalsPassageTarget = item.anchor;
        button.textContent = 'Passage ' + item.anchor.slice('paragraph-'.length);
        passageBookmarksList.appendChild(button);
        var remove = document.createElement('button'); remove.type = 'button';
        remove.textContent = 'Remove';
        remove.setAttribute('aria-label', 'Remove passage bookmark ' + item.anchor.slice('paragraph-'.length));
        remove.disabled = passageRemovalPending.has(passageKey(item));
        remove.addEventListener('click', function () { removePassageBookmark(item); });
        passageBookmarksList.appendChild(remove);
      });
    }
    function syncSavedCatalog() {
      var chapterIds = Array.isArray(config.chapters) ? config.chapters.map(function (chapter) { return chapter.id; }) : [activeChapterId()];
      root.querySelectorAll('[data-originals-catalog-item]').forEach(function (node) {
        var seriesId = node.dataset.seriesId;
        var saved = config.signedIn
          ? savedItems.some(function (item) { return item.seriesId === seriesId && ['favorite_series', 'saved_chapter'].includes(item.type); })
          : seriesId === 'just-the-homie' && (read('favorite:just-the-homie', {}).active || chapterIds.some(function (id) { return read('saved:' + id, {}).active; }));
        node.dataset.saved = saved ? 'true' : 'false';
      });
      if (typeof root.dispatchEvent === 'function') root.dispatchEvent(new Event('dsd:originals-savedchange'));
    }
    function accountWasChanged() {
      if (accountChanged) return;
      accountChanged = true; savedReady = false; savedItems = [];
      clearSleep();
      if (sleepSelect) { sleepSelect.value = 'off'; sleepSelect.disabled = true; }
      if (sleepStatus) sleepStatus.textContent = 'Your account changed. Sleep timer cleared; reload before setting another.';
      discussionRequest += 1; discussionItems = []; discussionNextPage = null; discussionLoading = false;
      if (discussionList) discussionList.replaceChildren();
      if (discussionStatus) discussionStatus.textContent = 'Your account changed. Reload this page to view discussion.';
      if (ratingStatus) ratingStatus.textContent = 'Your account changed. Reload this page to view your rating.';
      renderAccountSaves(); showSaveRetry(false);
      restoreManualState();
      announce('Your account changed. Reload this page before saving.');
    }
    function bookmarkFailure(error, label) {
      if (error.code === 'account_changed_reload') return accountWasChanged();
      if (error.code === 'saved_content_access_denied') return announce(label + ' was not saved. This chapter is no longer available to your account.');
      if (error.code === 'saved_content_changed') return announce(label + ' was not saved. The chapter changed; reopen it and try again.');
      if (error.code === 'access_policy_unavailable') return announce(label + ' was not saved. Access could not be checked; try again later.');
      announce(label + ' was not saved. Try again.');
    }
    function loadAccountSaves() {
      if (!accountSync || accountChanged) return;
      savedReady = false;
      showSaveRetry(false);
      savedApi('POST').then(function (data) {
        if (accountChanged) return;
        if (!Array.isArray(data.items)) throw new Error('saved_response_invalid');
        savedItems = data.items.filter(function (item) { return item && ['favorite_series', 'saved_chapter', 'audio_bookmark', 'text_bookmark'].includes(item.type); });
        savedReady = true;
        renderAccountSaves();
      }).catch(function (error) {
        if (accountChanged) return;
        if (error.code === 'account_changed_reload') return accountWasChanged();
        announce('Account saves could not be loaded. Retry to use account saves.'); showSaveRetry(true);
      });
    }
    function activeChapterId() { return root.dataset.originalsChapterId || config.chapterId || 'chapter-01'; }
    function activeAudioRevision() { return root.dataset.originalsAudioRevision || config.audioRevision; }
    function canonical(type) {
      if (window.DSDOriginalsRoutes) {
        var routes = window.DSDOriginalsRoutes.read(root.querySelector('[data-originals-public-routes]'));
        return new URL(window.DSDOriginalsRoutes.href({ view: type, seriesId: 'just-the-homie', chapterId: type === 'chapter' ? activeChapterId() : '' }, routes), location.origin).toString();
      }
      var url = new URL('/', location.origin);
      url.searchParams.set('view', type);
      url.searchParams.set('series', 'just-the-homie');
      if (type === 'chapter') url.searchParams.set('chapter', activeChapterId());
      return url.toString();
    }
    function copy(url) {
      if (!navigator.clipboard || !navigator.clipboard.writeText) return announce('Copy this link: ' + url);
      navigator.clipboard.writeText(url).then(function () { announce('Link copied.'); }).catch(function () { announce('Copy this link: ' + url); });
    }
    function share(type) {
      var url = canonical(type);
      var chapter = Array.isArray(config.chapters) && config.chapters.find(function (item) { return item.id === activeChapterId(); });
      var data = { title: type === 'chapter' ? 'Just the Homie — ' + (chapter && chapter.title || 'Chapter') : 'Just the Homie', text: 'Listen and read on DSD Originals.', url: url };
      if (navigator.share) navigator.share(data).then(function () { announce('Share sheet opened.'); }).catch(function (error) { if (error && error.name !== 'AbortError') copy(url); });
      else copy(url);
    }
    function toggle(button, key, onLabel, offLabel, type) {
      if (config.signedIn) {
        if (!accountSync || !savedReady || accountChanged) return void announce(accountChanged ? 'Your account changed. Reload this page before saving.' : 'Account saves are unavailable. Retry to load them.');
        var item = type === 'favorite_series' ? { type: type, seriesId: 'just-the-homie' } : { type: type, seriesId: 'just-the-homie', chapterId: activeChapterId() };
        var wasActive = hasAccountSave(type, item.chapterId);
        button.disabled = true;
        savedApi(wasActive ? 'DELETE' : 'PUT', item).then(function () {
          if (accountChanged) return;
          savedItems = savedItems.filter(function (saved) { return !(saved.type === type && saved.seriesId === item.seriesId && (type === 'favorite_series' || saved.chapterId === item.chapterId)); });
          if (!wasActive) savedItems.push(item);
          renderAccountSaves();
          announce(wasActive ? 'Removed from your DSD account.' : 'Saved to your DSD account.');
        }).catch(function (error) {
          if (accountChanged) return;
          if (error.code === 'account_changed_reload') return accountWasChanged();
          announce('Account save failed. Nothing was changed; try again.');
        }).finally(function () { button.disabled = false; });
        return;
      }
      var active = button.getAttribute('aria-pressed') !== 'true';
      button.setAttribute('aria-pressed', String(active));
      button.textContent = active ? onLabel : offLabel;
      var saved = write(key, { active: active, updatedAt: new Date().toISOString(), sync: config.signedIn ? 'pending' : 'local_only' });
      if (!saved) {
        button.setAttribute('aria-pressed', String(!active));
        button.textContent = active ? offLabel : onLabel;
      }
      announce(!saved ? 'Local save unavailable.' : 'Saved on this device. Sign in for account sync.');
      if (saved) syncSavedCatalog();
    }
    function restore(selector, key, label) {
      var button = root.querySelector(selector);
      if (button && read(key, {}).active) { button.setAttribute('aria-pressed', 'true'); button.textContent = label; }
    }
    function clearSleep() {
      if (sleepTimer) clearInterval(sleepTimer);
      sleepTimer = null; sleepDeadline = null; endSuppressesAutoNext = false;
    }
    function updateSleep() {
      if (!sleepDeadline) return;
      var remaining = sleepDeadline - Date.now();
      if (remaining <= 0) {
        audio.pause(); clearSleep(); sleepSelect.value = 'off'; sleepStatus.textContent = 'Sleep timer ended. Playback paused.'; return;
      }
      sleepStatus.textContent = 'Sleep timer: ' + Math.ceil(remaining / 60000) + ' min remaining.';
    }
    function setSleep(value) {
      clearSleep();
      if (accountChanged) return;
      if (value === 'off') return void (sleepStatus.textContent = 'Sleep timer off.');
      if (value === 'end') { endSuppressesAutoNext = true; sleepStatus.textContent = 'Playback will stop at the end of this chapter.'; return; }
      var minutes = Number(value);
      if (![15, 30].includes(minutes)) return;
      sleepDeadline = Date.now() + minutes * 60000;
      sleepTimer = setInterval(updateSleep, 1000); updateSleep();
    }
    function bookmark() {
      var position = audio && Number.isFinite(audio.currentTime) ? Math.round(audio.currentTime * 1000) / 1000 : 0;
      var item = { seriesId: 'just-the-homie', chapterId: activeChapterId(), audioRevision: activeAudioRevision(), positionSeconds: position, createdAt: new Date().toISOString() };
      if (config.signedIn) {
        if (!accountSync || !savedReady || accountChanged) return void announce(accountChanged ? 'Your account changed. Reload this page before saving.' : 'Account saves are unavailable. Retry to load them.');
        savedApi('PUT', { type: 'audio_bookmark', seriesId: item.seriesId, chapterId: item.chapterId, audioRevision: item.audioRevision, positionSeconds: item.positionSeconds }).then(function (data) {
          if (accountChanged) return;
          if (!data.item || data.item.type !== 'audio_bookmark' || data.item.seriesId !== item.seriesId || data.item.chapterId !== item.chapterId ||
              data.item.contentRevision !== item.audioRevision || data.item.positionSeconds !== item.positionSeconds || !/^timestamp-[0-9]+$/.test(String(data.item.anchor || ''))) throw new Error('saved_response_invalid');
          savedItems = savedItems.filter(function (saved) { return !(saved.type === 'audio_bookmark' && saved.chapterId === item.chapterId && saved.contentRevision === item.audioRevision && saved.anchor === data.item.anchor); });
          savedItems.unshift(data.item); renderAudioBookmarks();
          announce('Private account bookmark saved at ' + Math.floor(position / 60) + ':' + String(Math.floor(position % 60)).padStart(2, '0') + '.');
        }).catch(function (error) {
          if (accountChanged) return;
          bookmarkFailure(error, 'Account bookmark');
        });
        return;
      }
      var list = read('bookmarks', []);
      if (!Array.isArray(list)) list = [];
      list = list.filter(function (saved) { return !(saved.chapterId === item.chapterId && Math.abs(saved.positionSeconds - position) < 1); });
      list.unshift(item);
      if (!write('bookmarks', list.slice(0, 50))) return void announce('Local save unavailable.');
      renderAudioBookmarks();
      announce('Private timestamp bookmarked at ' + Math.floor(position / 60) + ':' + String(Math.floor(position % 60)).padStart(2, '0') + '.');
    }
    function bookmarkPassage() {
      var readPanel = root.querySelector('[data-originals-text-mode-panel="read"]');
      if (readPanel && readPanel.hidden) return void announce('Switch to Read to bookmark a passage.');
      var version = root.dataset.originalsProseRevision;
      var paragraphs = Array.from(root.querySelectorAll('[data-originals-read] [data-originals-prose-anchor]'));
      if (!version || !paragraphs.length) return void announce('Passage is not ready. Open the chapter and try again.');
      var viewportHeight = Number(window.innerHeight || 720);
      var focusY = viewportHeight * 0.42;
      var visible = paragraphs.filter(function (node) { var rect = node.getBoundingClientRect(); return rect.bottom > 0 && rect.top < viewportHeight; });
      if (!visible.length) return void announce('Scroll to the passage you want to bookmark.');
      var nearest = visible.reduce(function (best, node) {
        return Math.abs(node.getBoundingClientRect().top - focusY) < Math.abs(best.getBoundingClientRect().top - focusY) ? node : best;
      });
      var item = { type: 'text_bookmark', seriesId: 'just-the-homie', chapterId: activeChapterId(), textVersion: version, anchor: nearest.dataset.originalsProseAnchor };
      if (passageBookmarks().some(function (saved) { return saved.anchor === item.anchor; })) return void announce('This passage is already bookmarked.');
      if (config.signedIn) {
        if (!accountSync || !savedReady || accountChanged) return void announce(accountChanged ? 'Your account changed. Reload this page before saving.' : 'Account saves are unavailable. Retry to load them.');
        if (passageSavePending) return;
        passageSavePending = true;
        savedApi('PUT', item).then(function () {
          if (accountChanged) return;
          if (!passageBookmarks().some(function (saved) { return saved.anchor === item.anchor; })) savedItems.push(Object.assign({}, item, { contentRevision: version }));
          renderPassageBookmarks();
          announce('Passage saved to your DSD account.');
        }).catch(function (error) {
          if (accountChanged) return;
          bookmarkFailure(error, 'Passage bookmark');
        }).finally(function () { passageSavePending = false; });
        return;
      }
      var list = read('text-bookmarks', []);
      if (!Array.isArray(list)) list = [];
      list.unshift(item);
      if (!write('text-bookmarks', list.slice(0, 50))) return void announce('Local save unavailable.');
      renderPassageBookmarks();
      announce('Passage bookmarked on this device. Sign in for account sync.');
    }
    function sharePost() {
      var postingPolicy = window.DSDViewerPolicy;
      if (postingPolicy && typeof postingPolicy.canCreatePost === 'function' && !postingPolicy.canCreatePost()) {
        announce(config.signedIn
          ? 'Complete your profile setup before sharing to a post. Your chapter stays here.'
          : 'Sign in and complete your profile before sharing to a post. Your chapter stays here.');
        return;
      }
      var feed = new URL('/pages/feed', location.origin);
      feed.searchParams.set('compose', 'originals');
      feed.searchParams.set('ref', 'chapter');
      feed.searchParams.set('series', 'just-the-homie');
      feed.searchParams.set('chapter', activeChapterId());
      announce(postingPolicy
        ? 'Opening the canonical post composer. You choose the caption and audience before posting.'
        : 'Opening the post page. If profile setup is required, finish it and return to this chapter to share.');
      location.assign(feed.toString());
    }
    function showManualState(button, state) {
      if (!button) return;
      var finished = state === 'finished';
      button.dataset.state = finished ? 'finished' : 'not_started';
      button.textContent = finished ? 'Mark not started' : 'Mark finished';
      button.setAttribute('aria-pressed', String(finished));
    }
    function restoreManualState() {
      var button = root.querySelector('[data-originals-engagement="manual-state"]');
      if (!button) return;
      if (config.signedIn && accountChanged) {
        showManualState(button, null);
        button.hidden = true;
        button.disabled = true;
        return;
      }
      button.hidden = false;
      button.disabled = false;
      var saved = read('manual-state:' + activeChapterId(), null);
      showManualState(button, saved && saved.state);
    }
    function manualState(button) {
      if (config.signedIn && accountChanged) return void announce('Your account changed. Reload this page before saving.');
      var next = button.dataset.state === 'finished' ? 'not_started' : 'finished';
      if (!write('manual-state:' + activeChapterId(), { state: next, analyticsExcluded: true, updatedAt: new Date().toISOString() })) {
        return void announce('Local save unavailable.');
      }
      showManualState(button, next);
      announce('Private manual status saved on this device. It does not count as a listen or completion event.');
    }
    function discussionTarget() { return { targetType: 'chapter', targetId: activeChapterId() }; }
    function canonicalAction(path, payload) {
      return fetch('/apps/dsd-firebase-custom-token/supabase/' + path, { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify(payload) }).then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (value) { if (!response.ok) { var error = new Error(value.error || 'request_failed'); error.status = response.status; throw error; } return value; });
      });
    }
    function reactionButton(item, kind, label) {
      var button = document.createElement('button'); button.type = 'button'; button.className = 'dsd-originals-polish__comment-action'; button.dataset.originalsCommentReaction = kind; button.dataset.commentId = item.id; button.setAttribute('aria-pressed', String(item.viewerReaction === kind));
      var count = Number(item.reactions && item.reactions[kind] || 0); button.textContent = label + (count ? ' ' + count : ''); return button;
    }
    function renderComments(items) {
      if (!discussionList) return; discussionList.replaceChildren();
      if (!items || !items.length) { var empty = document.createElement('p'); empty.className = 'dsd-originals__meta'; empty.textContent = discussionNextPage !== null ? 'No visible comments on this page.' : 'No comments yet. Start the conversation.'; discussionList.appendChild(empty); }
      (items || []).forEach(function (item) {
        var article = document.createElement('article'); article.className = 'dsd-originals-polish__comment'; article.dataset.commentId = String(item.id || ''); article.dataset.profileKey = String(item.profileKey || ''); article.dataset.updatedAt = String(item.updatedAt || '');
        var meta = document.createElement('p'); meta.className = 'dsd-originals__meta'; meta.textContent = String(item.displayName || 'DSD member') + (item.createdAt ? ' · ' + new Date(item.createdAt).toLocaleString() : '') + (item.pending ? ' · Pending review (visible only to you)' : ''); article.appendChild(meta);
        var text = document.createElement('p'); text.textContent = item.spoiler ? 'Spoiler hidden.' : String(item.body || ''); article.appendChild(text);
        if (item.spoiler) { var reveal = document.createElement('button'); reveal.type = 'button'; reveal.textContent = 'Reveal spoiler'; reveal.addEventListener('click', function () { text.textContent = String(item.body || ''); reveal.remove(); }); article.appendChild(reveal); }
        if (config.signedIn) {
          var actions = document.createElement('div'); actions.className = 'dsd-originals-polish__comment-actions'; actions.setAttribute('aria-label', 'Comment actions');
          if (!item.pending) actions.append(reactionButton(item, 'like', 'Like'), reactionButton(item, 'love', 'Love'), reactionButton(item, 'laugh', 'Laugh'));
          if (item.viewerOwned) {
            if (!item.pending) { var edit = document.createElement('button'); edit.type = 'button'; edit.dataset.originalsCommentEdit = 'true'; edit.textContent = 'Edit'; actions.appendChild(edit); }
            var remove = document.createElement('button'); remove.type = 'button'; remove.dataset.originalsCommentDelete = 'true'; remove.textContent = 'Delete'; actions.appendChild(remove);
          } else {
            var report = document.createElement('button'); report.type = 'button'; report.dataset.originalsCommentReport = 'true'; report.dataset.commentId = String(item.id || ''); report.textContent = 'Report'; actions.appendChild(report);
            if (item.profileKey) { var block = document.createElement('button'); block.type = 'button'; block.dataset.originalsCommentBlock = 'true'; block.dataset.profileKey = String(item.profileKey); block.textContent = 'Block'; actions.appendChild(block); }
          }
          article.appendChild(actions);
        }
        discussionList.appendChild(article);
      });
      if (discussionMore && discussionNextPage !== null) { discussionMore.disabled = false; discussionList.appendChild(discussionMore); }
    }
    function loadDiscussion(page) {
      if (!discussionList || accountChanged && config.signedIn) return;
      var requestedPage = Number.isInteger(page) ? page : 0;
      if (requestedPage > 0 && (discussionLoading || discussionNextPage !== requestedPage)) return;
      var target = discussionTarget();
      var request = ++discussionRequest;
      discussionLoading = true;
      if (discussionMore) discussionMore.disabled = true;
      if (requestedPage === 0) { discussionItems = []; discussionNextPage = null; discussionList.replaceChildren(); }
      if (discussionStatus) discussionStatus.textContent = requestedPage ? 'Loading more comments…' : 'Loading discussion…';
      api('/discussion?targetType=' + encodeURIComponent(target.targetType) + '&targetId=' + encodeURIComponent(target.targetId) + '&page=' + requestedPage, 'GET').then(function (data) {
        if (accountChanged || request !== discussionRequest || target.targetId !== activeChapterId()) return;
        discussionLoading = false;
        var received = Array.isArray(data.items) ? data.items : [];
        if (requestedPage === 0) discussionItems = received;
        else {
          var known = new Set(discussionItems.map(function (item) { return String(item.id); }));
          received.forEach(function (item) { if (!known.has(String(item.id))) { discussionItems.push(item); known.add(String(item.id)); } });
        }
        discussionNextPage = Number.isInteger(data.nextPage) && data.nextPage > requestedPage && data.nextPage <= 100 ? data.nextPage : null;
        renderComments(discussionItems);
        if (discussionStatus) discussionStatus.textContent = data.pendingTruncated === true ? 'Showing your 50 most recent pending comments.' : data.truncated === true ? 'Comment history limit reached in this view.' : '';
      }).catch(function (error) {
        if (accountChanged || request !== discussionRequest || target.targetId !== activeChapterId()) return;
        discussionLoading = false;
        if (requestedPage > 0) renderComments(discussionItems);
        if (discussionStatus) discussionStatus.textContent = requestedPage > 0 ? 'More comments could not be loaded. Try again.' : error.status === 503 ? 'Discussion is waiting for the canonical DSD social adapter release.' : 'Discussion is temporarily unavailable.';
      });
    }

    root.addEventListener('click', function (event) {
      if (accountChanged && config.signedIn) {
        var publicShare = event.target.closest('[data-originals-engagement]');
        if (!publicShare || !['share-series', 'share-chapter'].includes(publicShare.dataset.originalsEngagement)) {
          return void announce('Your account changed. Reload this page before using account actions.');
        }
      }
      var passageTarget = event.target.closest('[data-originals-passage-target]');
      if (passageTarget) {
        var destination = Array.from(root.querySelectorAll('[data-originals-read] [data-originals-prose-anchor]')).find(function (node) { return node.dataset.originalsProseAnchor === passageTarget.dataset.originalsPassageTarget; });
        if (destination) { destination.scrollIntoView({ block: 'center' }); destination.tabIndex = -1; destination.focus({ preventScroll: true }); }
        return;
      }
      var reaction = event.target.closest('[data-originals-comment-reaction]');
      if (reaction) {
        var reactionArticle = reaction.closest('.dsd-originals-polish__comment');
        if (!reactionArticle || reactionArticle.dataset.reactionPending === 'true') return;
        reactionArticle.dataset.reactionPending = 'true';
        var reactionButtons = Array.from(reactionArticle.querySelectorAll('[data-originals-comment-reaction]'));
        reactionButtons.forEach(function (button) { button.disabled = true; });
        var removingReaction = reaction.getAttribute('aria-pressed') === 'true';
        event.preventDefault(); discussionStatus.textContent = 'Saving reaction…';
        api('/discussion/reaction', removingReaction ? 'DELETE' : 'PUT', { commentId: reaction.dataset.commentId, reaction: reaction.dataset.originalsCommentReaction, idempotencyKey: 'originals-reaction-' + Date.now() }).then(function () { if (accountChanged) return; discussionStatus.textContent = removingReaction ? 'Reaction removed.' : 'Reaction saved.'; return loadDiscussion(); }).catch(function () { if (!accountChanged) discussionStatus.textContent = 'Reaction was not saved.'; }).then(function () { reactionArticle.dataset.reactionPending = 'false'; reactionButtons.forEach(function (button) { button.disabled = false; }); }); return;
      }
      var editComment = event.target.closest('[data-originals-comment-edit]');
      if (editComment) {
        event.preventDefault();
        var editArticle = editComment.closest('[data-comment-id]');
        if (!editArticle || editArticle.querySelector('[data-originals-comment-edit-form]')) return;
        var editItem = discussionItems.find(function (item) { return String(item.id) === editArticle.dataset.commentId && item.viewerOwned; });
        if (!editItem) return;
        var form = document.createElement('form'); form.dataset.originalsCommentEditForm = 'true';
        var label = document.createElement('label'); label.textContent = 'Edit your comment';
        var field = document.createElement('textarea'); field.name = 'body'; field.required = true; field.maxLength = 1200; field.value = String(editItem.body || ''); label.appendChild(field); form.appendChild(label);
        var save = document.createElement('button'); save.type = 'submit'; save.textContent = 'Save for review'; form.appendChild(save);
        var cancel = document.createElement('button'); cancel.type = 'button'; cancel.textContent = 'Cancel'; cancel.addEventListener('click', function () { form.remove(); }); form.appendChild(cancel);
        editArticle.appendChild(form); field.focus(); return;
      }
      var deleteComment = event.target.closest('[data-originals-comment-delete]');
      if (deleteComment) {
        event.preventDefault();
        var deleteArticle = deleteComment.closest('[data-comment-id]');
        if (!deleteArticle) return;
        var owned = discussionItems.some(function (item) { return String(item.id) === deleteArticle.dataset.commentId && item.viewerOwned; });
        if (!owned) return;
        if (deleteComment.dataset.confirmDelete !== 'true') {
          deleteComment.dataset.confirmDelete = 'true'; deleteComment.textContent = 'Confirm delete';
          if (discussionStatus) discussionStatus.textContent = 'Select Confirm delete to remove your comment.';
          return;
        }
        deleteComment.disabled = true;
        api('/discussion/comment', 'DELETE', Object.assign(discussionTarget(), { commentId:deleteArticle.dataset.commentId, expectedUpdatedAt:deleteArticle.dataset.updatedAt, idempotencyKey:'originals-delete-' + Date.now() })).then(function () {
          if (accountChanged) return;
          if (discussionStatus) discussionStatus.textContent = 'Comment deleted.'; loadDiscussion();
        }).catch(function (error) {
          if (accountChanged) return;
          deleteComment.disabled = false; deleteComment.dataset.confirmDelete = 'false'; deleteComment.textContent = 'Delete';
          if (discussionStatus) discussionStatus.textContent = error.status === 409 ? 'This comment changed. Reload discussion before deleting.' : 'Comment was not deleted.';
        }); return;
      }
      var report = event.target.closest('[data-originals-comment-report]');
      if (report) {
        event.preventDefault(); discussionStatus.textContent = 'Submitting report…';
        canonicalAction('safety-report', { reportId: 'originals-report-' + Date.now(), targetType: 'comment', targetId: report.dataset.commentId, sourcePath: location.pathname + location.search, details: 'Reported from DSD Originals discussion.' }).then(function () { if (!accountChanged) discussionStatus.textContent = 'Report submitted for moderation review.'; }).catch(function () { if (!accountChanged) discussionStatus.textContent = 'Report was not submitted.'; }); return;
      }
      var block = event.target.closest('[data-originals-comment-block]');
      if (block) {
        event.preventDefault(); discussionStatus.textContent = 'Blocking profile…';
        canonicalAction('relationship-decision', { action: 'block', targetProfileKey: block.dataset.profileKey, idempotencyKey: 'originals-block-' + Date.now() }).then(function () { if (accountChanged) return; discussionStatus.textContent = 'Profile blocked. Their comments are hidden.'; loadDiscussion(); }).catch(function () { if (!accountChanged) discussionStatus.textContent = 'Profile was not blocked.'; }); return;
      }
      var button = event.target.closest('[data-originals-engagement]'); if (!button) return;
      var action = button.dataset.originalsEngagement;
      if (action === 'favorite') toggle(button, 'favorite:just-the-homie', 'Favorited', 'Favorite series', 'favorite_series');
      if (action === 'save-chapter') toggle(button, 'saved:' + activeChapterId(), 'Saved', 'Save chapter', 'saved_chapter');
      if (action === 'bookmark') bookmark();
      if (action === 'bookmark-passage') bookmarkPassage();
      if (action === 'share-series') share('series');
      if (action === 'share-chapter') share('chapter');
      if (action === 'share-post') sharePost();
      if (action === 'manual-state') manualState(button);
    });
    root.addEventListener('submit', function (event) {
      if (accountChanged && config.signedIn) { event.preventDefault(); return void announce('Your account changed. Reload this page before using account actions.'); }
      var form = event.target.closest('[data-originals-comment-edit-form]');
      if (!form) return;
      event.preventDefault();
      var article = form.closest('[data-comment-id]');
      if (!article) return;
      var message = String(new FormData(form).get('body') || '').trim();
      if (!message || message.length > 1200) { if (discussionStatus) discussionStatus.textContent = 'Comment must be 1–1,200 characters.'; return; }
      var save = form.querySelector('[type="submit"]'); if (save) save.disabled = true;
      api('/discussion/comment', 'PUT', Object.assign(discussionTarget(), { commentId:article.dataset.commentId, expectedUpdatedAt:article.dataset.updatedAt, body:message, idempotencyKey:'originals-edit-' + Date.now() })).then(function () {
        if (accountChanged) return;
        if (discussionStatus) discussionStatus.textContent = 'Edit submitted for moderation review. It will reappear after approval.';
        loadDiscussion();
      }).catch(function (error) {
        if (accountChanged) return;
        if (save) save.disabled = false;
        if (discussionStatus) discussionStatus.textContent = error.status === 409 ? 'This comment changed. Reload discussion before editing.' : 'Edit was not saved.';
      });
    });
    if (sleepSelect) sleepSelect.addEventListener('change', function () { setSleep(sleepSelect.value); });
    root.addEventListener('dsd:originals-beforeautonext', function (event) {
      if (sleepDeadline && Date.now() >= sleepDeadline) {
        event.preventDefault();
        updateSleep();
        return;
      }
      if (!endSuppressesAutoNext) return;
      event.preventDefault();
      endSuppressesAutoNext = false;
      if (sleepSelect) sleepSelect.value = 'off';
      if (sleepStatus) sleepStatus.textContent = 'Sleep timer stopped automatic continuation.';
    });
    if (audio) {
      document.addEventListener('visibilitychange', function () { if (!document.hidden) updateSleep(); });
      window.addEventListener('pageshow', updateSleep);
      audio.addEventListener('playing', updateSleep);
    }
    if (ratingForm) ratingForm.addEventListener('submit', function (event) {
      event.preventDefault();
      if (accountChanged) { ratingStatus.textContent = 'Your account changed. Reload this page before rating.'; return; }
      if (!config.signedIn) { ratingStatus.textContent = 'Sign in to rate this series.'; return; }
      var data = new FormData(ratingForm); var rating = Number(data.get('rating'));
      if (!Number.isInteger(rating) || rating < 1 || rating > 5) { ratingStatus.textContent = 'Choose a rating from 1 to 5.'; return; }
      var payload = { seriesId: 'just-the-homie', rating: rating, reviewText: String(data.get('review') || '').slice(0, 4000), spoiler: data.get('spoiler') === 'on' };
      ratingStatus.textContent = 'Saving rating…';
      api('/rating', 'PUT', payload).then(function () { if (!accountChanged) ratingStatus.textContent = 'Rating saved to your DSD account.'; }).catch(function () { if (!accountChanged) ratingStatus.textContent = 'Rating was not saved. Please try again when the account service is available.'; });
    });
    if (discussionForm) discussionForm.addEventListener('submit', function (event) {
      event.preventDefault(); if (accountChanged) { discussionStatus.textContent = 'Your account changed. Reload this page before posting.'; return; }
      if (!config.signedIn) { discussionStatus.textContent = 'Sign in to join the discussion.'; return; }
      var data = new FormData(discussionForm); var message = String(data.get('body') || '').trim(); if (!message) return;
      var payload = Object.assign(discussionTarget(), { body: message.slice(0, 1200), spoiler: data.get('spoiler') === 'on', idempotencyKey: 'originals-' + Date.now() });
      discussionStatus.textContent = 'Posting comment…';
      api('/discussion', 'POST', payload).then(function () { if (accountChanged) return; discussionForm.reset(); discussionStatus.textContent = 'Comment posted.'; loadDiscussion(); }).catch(function (error) { if (!accountChanged) discussionStatus.textContent = error.status === 503 ? 'Posting is waiting for the canonical DSD social adapter release.' : 'Comment was not posted.'; });
    });
    saveRetryButtons.forEach(function (button) { button.addEventListener('click', loadAccountSaves); });
    if (config.signedIn && typeof window.addEventListener === 'function') {
      ['dsd:shopify-account:changed', 'dsd:shopify-logout'].forEach(function (name) {
        window.addEventListener(name, accountWasChanged);
      });
    }
    restoreManualState();
    if (config.signedIn) {
      if (accountSync) loadAccountSaves();
      else announce('Account saves are unavailable. Reload after signing in again.');
    } else {
      restore('[data-originals-engagement="favorite"]', 'favorite:just-the-homie', 'Favorited');
      restore('[data-originals-engagement="save-chapter"]', 'saved:' + activeChapterId(), 'Saved');
      syncSavedCatalog();
      renderPassageBookmarks();
      renderAudioBookmarks();
    }
    loadDiscussion();
    root.addEventListener('dsd:originals-chapterchange', function () {
      restoreManualState();
      var saveButton = root.querySelector('[data-originals-engagement="save-chapter"]');
      if (saveButton) { saveButton.setAttribute('aria-pressed', 'false'); saveButton.textContent = 'Save chapter'; }
      if (config.signedIn) renderAccountSaves();
      else restore('[data-originals-engagement="save-chapter"]', 'saved:' + activeChapterId(), 'Saved');
      renderPassageBookmarks();
      renderAudioBookmarks();
      loadDiscussion();
    });
    root.addEventListener('dsd:originals-proseready', renderPassageBookmarks);
  }
  document.querySelectorAll('[data-dsd-originals-library]').forEach(boot);
  document.addEventListener('shopify:section:load', function (event) { event.target.querySelectorAll('[data-dsd-originals-library]').forEach(boot); });
})();
